var map = {
	"./v10": 1028,
	"./v10/": 1028,
	"./v10/BaseSlideTemplate": 51116,
	"./v10/BaseSlideTemplate.js": 51116,
	"./v10/index": 1028,
	"./v10/index.js": 1028,
	"./v10/templatesData": 49884,
	"./v10/templatesData/": 49884,
	"./v10/templatesData/chartUtils": 91652,
	"./v10/templatesData/chartUtils.js": 91652,
	"./v10/templatesData/classicTemplates": 26461,
	"./v10/templatesData/classicTemplates.js": 26461,
	"./v10/templatesData/devTemplates": 99528,
	"./v10/templatesData/devTemplates.js": 99528,
	"./v10/templatesData/index": 49884,
	"./v10/templatesData/index.js": 49884,
	"./v10/templatesData/obsoleteTemplates": 51558,
	"./v10/templatesData/obsoleteTemplates.js": 51558,
	"./v10/templatesData/tableUtils": 84131,
	"./v10/templatesData/tableUtils.js": 84131,
	"./v10/templatesData/templates": 19987,
	"./v10/templatesData/templates.js": 19987,
	"./v10/templatesData/variations": 7504,
	"./v10/templatesData/variations.js": 7504,
	"./v9": 89676,
	"./v9/": 89676,
	"./v9/BaseSlideTemplate": 72612,
	"./v9/BaseSlideTemplate.js": 72612,
	"./v9/index": 89676,
	"./v9/index.js": 89676,
	"./v9/templatesData": 51860,
	"./v9/templatesData/": 51860,
	"./v9/templatesData/chartUtils": 21503,
	"./v9/templatesData/chartUtils.js": 21503,
	"./v9/templatesData/classicTemplates": 63925,
	"./v9/templatesData/classicTemplates.js": 63925,
	"./v9/templatesData/devTemplates": 34496,
	"./v9/templatesData/devTemplates.js": 34496,
	"./v9/templatesData/index": 51860,
	"./v9/templatesData/index.js": 51860,
	"./v9/templatesData/obsoleteTemplates": 20158,
	"./v9/templatesData/obsoleteTemplates.js": 20158,
	"./v9/templatesData/templates": 36059,
	"./v9/templatesData/templates.js": 36059,
	"./v9/templatesData/variations": 57256,
	"./v9/templatesData/variations.js": 57256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91474;